// // import React from "react";
// // import { useDispatch } from "react-redux";
// // import EditModal from "../common/EditModal";
// // import { updateAdmissionDetails } from "../../redux/actions/admin/admissionAction";

// // const EditAdmissionDetails = ({
// //   id,
// //   studentName,
// //   fatherName,
// //   motherName,
// //   email,
// //   phone,
// //   studentDoB,
// //   classApplied,
// //   address,
// //   refreshData,
// // }) => {
// //   const dispatch = useDispatch();

// //   const formFields = [
// //     {
// //       name: "studentName",
// //       label: "Student Name",
// //       value: studentName,
// //       placeholder: "Student Name",
// //     },
// //     {
// //       name: "fatherName",
// //       label: "Father Name",
// //       value: fatherName,
// //       placeholder: "Father Name",
// //     },
// //      {
// //       name: "motherName",
// //       label: "Mother Name",
// //       value: motherName,
// //       placeholder: "Mother Name",
// //     },
     
// //     { name: "email", label: "E-mail", value: email, placeholder: "E-mail" },
// //     { name: "phone", label: "Phone Number", value: phone, placeholder: "Phone Number" },
// //     {
// //       name: "studentDoB",
// //       label: "Student DOB",
// //       value: studentDoB,
// //       placeholder: "Student DOB",
// //     },
// //     {
// //       name: "classApplied",
// //       label: "Class Applied",
// //       value: classApplied,
// //       placeholder: "Class Applied",
// //     },
// //     {
// //       name: "address",
// //       label: "Address",
// //       value: address,
// //       placeholder: "Address",
// //     },
// //   ];

// //   // Handle the form data update
// //   const handleUpdate = async (updatedData) => {
// //     await dispatch(updateAdmissionDetails(id, updatedData));
// //     refreshData();
// //   };

// //   return (
// //     <>
// //       <EditModal
// //         title="Edit Admission Details"
// //         formFields={formFields}
// //         onSubmit={handleUpdate}
// //         buttonName="Update Admission"
// //         modelTitle="Are you sure you want to edit these admission details?"
// //         content="Please confirm to apply the changes made to this admission."
// //         okText="Yes, Change"
// //         cancelText="No, Cancel"
// //       />
// //     </>
// //   );
// // };

// // export default EditAdmissionDetails;

// import React from "react";
// import { useDispatch } from "react-redux";
// import EditModal from "../common/EditModal";
// import { updateAdmissionDetails } from "../../redux/actions/admin/admissionAction";

// const EditAdmissionDetails = ({
//   id,
//   studentName,
//   fatherName,
//   motherName,
//   birthDate,
//   gender,
//   presentAddress,
//   permanentAddress,
//   phone,
//   email,
//   courseName,
//   className,
//   refreshData,
//   presentDivision,
//   presentDistrict,
//   permanentDivision,
//   permanentDistrict,
//   paymentDate
// }) => {
//   const dispatch = useDispatch();

//   const formFields = [
//     {
//       name: "studentName",
//       label: "Student Name",
//       value: studentName,
//       placeholder: "Enter student name",
//       type: "text",
//       required: true
//     },
//     {
//       name: "fatherName",
//       label: "Father Name",
//       value: fatherName,
//       placeholder: "Enter father name",
//       type: "text",
//       required: true
//     },
//     {
//       name: "motherName",
//       label: "Mother Name",
//       value: motherName,
//       placeholder: "Enter mother name",
//       type: "text",
//       required: true
//     },
//     {
//       name: "birthDate",
//       label: "Date of Birth",
//       value: birthDate,
//       placeholder: "Select date of birth",
//       // type: "date",
//       required: true
//     },
//     {
//       name: "gender",
//       label: "Gender",
//       value: gender,
//       placeholder: "Select gender",
//       type: "select",
//       options: [
//         { value: "Male", label: "Male" },
//         { value: "Female", label: "Female" },
//         { value: "Other", label: "Other" }
//       ],
//       required: true
//     },
//     {
//       name: "phone",
//       label: "Phone Number",
//       value: phone,
//       placeholder: "Enter phone number",
//       type: "text",
//       required: true
//     },
//     {
//       name: "email",
//       label: "Email Address",
//       value: email,
//       placeholder: "Enter email address",
//       type: "email",
//       required: true
//     },
//     {
//       name: "courseName",
//       label: "Course Name",
//       value: courseName,
//       placeholder: "Select course",
//       type: "select",
//       options: [
//         { value: "", label: "Select Course" },
//         { value: "Navodaya", label: "Navodaya Vidyalaya Preparation" },
//         { value: "RIMC", label: "RIMC (Rashtriya Indian Military College)" },
//         { value: "Sainik", label: "Sainik School" },
//         { value: "Military", label: "Military School" },
//       ]
//     },
//     {
//       name: "className",
//       label: "Class Name",
//       value: className,
//       placeholder: "Select class",
//     },
//     {
//       name: "presentDivision",
//       label: "Present Division",
//       value: presentDivision,
//       placeholder: "Enter present division",
//       type: "text"
//     },
//     {
//       name: "presentDistrict",
//       label: "Present District",
//       value: presentDistrict,
//       placeholder: "Enter present district",
//       type: "text"
//     },
//     {
//       name: "presentAddress",
//       label: "Present Address",
//       value: presentAddress,
//       placeholder: "Enter complete present address",
//       type: "textarea",
//       rows: 3
//     },
//     {
//       name: "permanentDivision",
//       label: "Permanent Division",
//       value: permanentDivision,
//       placeholder: "Enter permanent division",
//       type: "text"
//     },
//     {
//       name: "permanentDistrict",
//       label: "Permanent District",
//       value: permanentDistrict,
//       placeholder: "Enter permanent district",
//       type: "text"
//     },
//     {
//       name: "permanentAddress",
//       label: "Permanent Address",
//       value: permanentAddress,
//       placeholder: "Enter complete permanent address",
//       type: "textarea",
//       rows: 3
//     },
   
//     {
//       name: "paymentDate",
//       label: "Payment Date",
//       value: paymentDate ? new Date(paymentDate).toISOString().split('T')[0] : "",
//       placeholder: "Select payment date",
//       type: "date"
//     }
//   ];

//   // Handle the form data update
//   const handleUpdate = async (updatedData) => {
//     // Format dates properly
//     if (updatedData.birthDate) {
//       updatedData.birthDate = new Date(updatedData.birthDate).toISOString();
//     }
//     if (updatedData.paymentDate) {
//       updatedData.paymentDate = new Date(updatedData.paymentDate).toISOString();
//     }
    
//     await dispatch(updateAdmissionDetails(id, updatedData));
//     if (refreshData) refreshData();
//   };

//   return (
//     <>
//       <EditModal
//         title="Edit Admission Details"
//         formFields={formFields}
//         onSubmit={handleUpdate}
//         buttonName="Update Admission"
//         modelTitle="Update Admission Details"
//         content="Are you sure you want to update this admission record?"
//         okText="Yes, Update"
//         cancelText="No, Cancel"
//         width="md" // You can adjust modal size: 'xs', 'sm', 'md', 'lg', 'xl'
//       />
//     </>
//   );
// };

// export default EditAdmissionDetails;

import React, { useState } from "react";
import { useDispatch } from "react-redux";
import {
  Modal,
  Box,
  Typography,
  TextField,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  IconButton,
  Tooltip,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import { updateAdmissionDetails } from "../../redux/actions/admin/admissionAction";

const EditAdmissionDetails = ({
  id,
  studentName,
  fatherName,
  motherName,
  birthDate,
  gender,
  presentAddress,
  permanentAddress,
  phone,
  email,
  courseName,
  className,
  refreshData,
  presentDivision,
  presentDistrict,
  permanentDivision,
  permanentDistrict,
  paymentDate,
  transactionId,
  paymentStatus,
  totalFees,
}) => {
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [openConfirm, setOpenConfirm] = useState(false);
  const [formData, setFormData] = useState(() => {
    // Format dates properly for input fields
    const formattedBirthDate = birthDate 
      ? new Date(birthDate).toISOString().split('T')[0]
      : "";
    
    const formattedPaymentDate = paymentDate 
      ? new Date(paymentDate).toISOString().split('T')[0]
      : "";

    return {
      studentName: studentName || "",
      fatherName: fatherName || "",
      motherName: motherName || "",
      birthDate: formattedBirthDate,
      gender: gender || "Male",
      phone: phone || "",
      email: email || "",
      courseName: courseName || "",
      className: className || "",
      presentDivision: presentDivision || "",
      presentDistrict: presentDistrict || "",
      presentAddress: presentAddress || "",
      permanentDivision: permanentDivision || "",
      permanentDistrict: permanentDistrict || "",
      permanentAddress: permanentAddress || "",
      transactionId: transactionId || "",
      paymentStatus: paymentStatus || "Pending",
      totalFees: totalFees || 7000,
      paymentDate: formattedPaymentDate,
    };
  });

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = () => {
    setOpenConfirm(true);
  };

  const handleConfirm = async () => {
    try {
      // Format dates properly before sending to backend
      const dataToSend = { ...formData };
      
      if (dataToSend.birthDate) {
        dataToSend.birthDate = new Date(dataToSend.birthDate).toISOString();
      }
      
      if (dataToSend.paymentDate) {
        dataToSend.paymentDate = new Date(dataToSend.paymentDate).toISOString();
      }
      
      await dispatch(updateAdmissionDetails(id, dataToSend));
      
      if (refreshData) {
        refreshData();
      }
      
      setOpenConfirm(false);
      handleClose();
      
      // Reset form data with updated values
      setFormData(prev => ({ ...prev }));
      
    } catch (error) {
      console.error("Update error:", error);
    }
  };

  const handleCancelConfirm = () => {
    setOpenConfirm(false);
  };

  const formatDateForDisplay = (dateString) => {
    if (!dateString) return "Not set";
    const date = new Date(dateString);
    return date.toLocaleDateString('en-IN', {
      day: '2-digit',
      month: 'short',
      year: 'numeric'
    });
  };

  const courseOptions = [
    { value: "", label: "Select Course" },
    { value: "Navodaya", label: "Navodaya Vidyalaya Preparation" },
    { value: "RIMC", label: "RIMC (Rashtriya Indian Military College)" },
    { value: "Sainik", label: "Sainik School" },
    { value: "Military", label: "Military School" },
    { value: "Other", label: "Other Course" },
  ];

  const paymentStatusOptions = [
    { value: "Pending", label: "Pending" },
    { value: "Completed", label: "Completed" },
    { value: "Failed", label: "Failed" },
  ];

  return (
    <>
      <Tooltip title="Edit Admission Details">
        <IconButton 
          color="primary" 
          onClick={handleOpen}
          size="small"
        >
          <EditIcon />
        </IconButton>
      </Tooltip>

      {/* Edit Modal */}
      <Modal open={open} onClose={handleClose}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 600,
            maxWidth: "95vw",
            maxHeight: "90vh",
            overflowY: "auto",
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            borderRadius: 2,
          }}
        >
          <Typography variant="h5" gutterBottom sx={{ color: "#065A79" }}>
            Edit Admission Details
          </Typography>
          
          <Typography variant="subtitle2" color="textSecondary" gutterBottom>
            Admission ID: {id?.substring(0, 10)}...
          </Typography>

          <Box component="form" sx={{ mt: 2 }}>
            {/* Personal Information */}
            <Typography variant="h6" sx={{ mt: 2, mb: 1, color: "#AD1C86" }}>
              Personal Information
            </Typography>
            
            <Box sx={{ display: "flex", gap: 2, mb: 2 }}>
              <TextField
                name="studentName"
                label="Student Name *"
                value={formData.studentName}
                onChange={handleChange}
                fullWidth
                required
                size="small"
              />
              <TextField
                name="birthDate"
                label="Date of Birth *"
                type="date"
                value={formData.birthDate}
                onChange={handleChange}
                fullWidth
                required
                size="small"
                InputLabelProps={{ shrink: true }}
              />
            </Box>

            <Box sx={{ display: "flex", gap: 2, mb: 2 }}>
              <TextField
                name="fatherName"
                label="Father's Name *"
                value={formData.fatherName}
                onChange={handleChange}
                fullWidth
                required
                size="small"
              />
              <TextField
                name="motherName"
                label="Mother's Name *"
                value={formData.motherName}
                onChange={handleChange}
                fullWidth
                required
                size="small"
              />
            </Box>

            <Box sx={{ display: "flex", gap: 2, mb: 2 }}>
              <FormControl fullWidth size="small">
                <InputLabel>Gender *</InputLabel>
                <Select
                  name="gender"
                  value={formData.gender}
                  onChange={handleChange}
                  label="Gender *"
                >
                  <MenuItem value="Male">Male</MenuItem>
                  <MenuItem value="Female">Female</MenuItem>
                  <MenuItem value="Other">Other</MenuItem>
                </Select>
              </FormControl>
              
              <TextField
                name="phone"
                label="Phone Number *"
                value={formData.phone}
                onChange={handleChange}
                fullWidth
                required
                size="small"
              />
            </Box>

            <TextField
              name="email"
              label="Email Address *"
              type="email"
              value={formData.email}
              onChange={handleChange}
              fullWidth
              required
              size="small"
              sx={{ mb: 2 }}
            />

            {/* Course/Class Information */}
            <Typography variant="h6" sx={{ mt: 2, mb: 1, color: "#AD1C86" }}>
              Academic Information
            </Typography>
            
            <Box sx={{ display: "flex", gap: 2, mb: 2 }}>
              <FormControl fullWidth size="small">
                <InputLabel>Course Name</InputLabel>
                <Select
                  name="courseName"
                  value={formData.courseName}
                  onChange={handleChange}
                  label="Course Name"
                >
                  {courseOptions.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <TextField
              name="className"
              label="Class Name"
              value={formData.className}
              onChange={handleChange}
              fullWidth
              size="small"
              sx={{ mb: 2 }}
            />
            </Box>

            {/* Address Information */}
            <Typography variant="h6" sx={{ mt: 2, mb: 1, color: "#AD1C86" }}>
              Address Information
            </Typography>
            
            <Typography variant="subtitle2" sx={{ mb: 1 }}>
              Present Address
            </Typography>
            
            <Box sx={{ display: "flex", gap: 2, mb: 2 }}>
              <TextField
                name="presentDivision"
                label="Division"
                value={formData.presentDivision}
                onChange={handleChange}
                fullWidth
                size="small"
              />
              <TextField
                name="presentDistrict"
                label="District"
                value={formData.presentDistrict}
                onChange={handleChange}
                fullWidth
                size="small"
              />
            </Box>

            <TextField
              name="presentAddress"
              label="Present Address"
              value={formData.presentAddress}
              onChange={handleChange}
              multiline
              rows={2}
              fullWidth
              size="small"
              sx={{ mb: 2 }}
            />

            <Typography variant="subtitle2" sx={{ mb: 1 }}>
              Permanent Address
            </Typography>
            
            <Box sx={{ display: "flex", gap: 2, mb: 2 }}>
              <TextField
                name="permanentDivision"
                label="Division"
                value={formData.permanentDivision}
                onChange={handleChange}
                fullWidth
                size="small"
              />
              <TextField
                name="permanentDistrict"
                label="District"
                value={formData.permanentDistrict}
                onChange={handleChange}
                fullWidth
                size="small"
              />
            </Box>

            <TextField
              name="permanentAddress"
              label="Permanent Address"
              value={formData.permanentAddress}
              onChange={handleChange}
              multiline
              rows={2}
              fullWidth
              size="small"
              sx={{ mb: 2 }}
            />

            {/* Payment Information */}
            <Typography variant="h6" sx={{ mt: 2, mb: 1, color: "#AD1C86" }}>
              Payment Information
            </Typography>
            
            <Box sx={{ display: "flex", gap: 2, mb: 2 }}>
              <TextField
                name="transactionId"
                label="Transaction ID"
                value={formData.transactionId}
                onChange={handleChange}
                fullWidth
                size="small"
              />
              
              <TextField
                name="totalFees"
                label="Total Fees (₹)"
                value={formData.totalFees}
                onChange={handleChange}
                type="number"
                fullWidth
                size="small"
                InputProps={{
                  readOnly: true,
                }}
              />
            </Box>

            <Box sx={{ display: "flex", gap: 2, mb: 2 }}>
              <FormControl fullWidth size="small">
                <InputLabel>Payment Status</InputLabel>
                <Select
                  name="paymentStatus"
                  value={formData.paymentStatus}
                  onChange={handleChange}
                  label="Payment Status"
                >
                  {paymentStatusOptions.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              <TextField
                name="paymentDate"
                label="Payment Date"
                type="date"
                value={formData.paymentDate}
                onChange={handleChange}
                fullWidth
                size="small"
                InputLabelProps={{ shrink: true }}
              />
            </Box>

            {/* Summary */}
            <Box sx={{ 
              mt: 3, 
              p: 2, 
              backgroundColor: '#f5f5f5', 
              borderRadius: 1,
              borderLeft: '4px solid #065A79'
            }}>
              <Typography variant="subtitle2" sx={{ color: '#065A79', mb: 1 }}>
                Current Information Summary
              </Typography>
              <Typography variant="body2">
                <strong>Birth Date:</strong> {formatDateForDisplay(birthDate)} | 
                <strong> Payment Date:</strong> {formatDateForDisplay(paymentDate)}
              </Typography>
            </Box>

            {/* Action Buttons */}
            <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 2, mt: 3 }}>
              <Button onClick={handleClose} variant="outlined" size="small">
                Cancel
              </Button>
              <Button 
                onClick={handleSubmit} 
                variant="contained" 
                color="primary"
                size="small"
              >
                Update Details
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>

      {/* Confirmation Dialog */}
      <Dialog open={openConfirm} onClose={handleCancelConfirm}>
        <DialogTitle>Confirm Update</DialogTitle>
        <DialogContent>
          <Typography>
            Are you sure you want to update admission details for <strong>{studentName}</strong>?
          </Typography>
          <Typography variant="body2" color="textSecondary" sx={{ mt: 1 }}>
            Admission ID: {id?.substring(0, 10)}...
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancelConfirm} color="primary">
            No, Cancel
          </Button>
          <Button onClick={handleConfirm} color="primary" variant="contained">
            Yes, Update
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default EditAdmissionDetails;